import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[buttonProgressBar]',
    standalone: true,
})
export class MaterialButtonProgressBarDirective implements OnChanges {
    /**
     * true to active animation
     * {boolean}
     */
    @Input() public buttonProgressBar: boolean;
    /**
     * duration of animation in seconds
     * @type {string}
     */
    @Input() public duration = '6';
    /**
     * is button clicked
     * @type {boolean}
     */
    private isClicked = false;

    public constructor(
        private readonly el: ElementRef,
        private readonly renderer: Renderer2,
    ) {}

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.buttonProgressBar.currentValue === true) {
            this.initProgressBarButton();
        } else if (this.isClicked) {
            this.resetButton();
        }
    }

    /**
     * initialize progress button bar
     */
    private initProgressBarButton(): void {
        this.isClicked = true;
        this.renderer.setAttribute(this.el.nativeElement, 'disabled', 'true');
        this.renderer.setAttribute(this.el.nativeElement, 'data-ob1-component', 'ProgressBarDetermined');
        const spanInButton = this.renderer.createElement('span');
        this.renderer.addClass(spanInButton, 'ob1-progress-bar-determined');
        this.renderer.setStyle(spanInButton, 'animation-duration', '500ms, ' + this.duration + 's, 500ms');
        this.renderer.setStyle(spanInButton, 'animation-delay', '0s, 500ms, ' + this.duration + '.5s');
        const innerBar = this.renderer.createElement('span');
        this.renderer.addClass(innerBar, 'ob1-progress-bar-determined-inner');
        this.renderer.setStyle(innerBar, 'animation-duration', this.duration + 's');
        this.renderer.appendChild(spanInButton, innerBar);
        this.renderer.appendChild(this.el.nativeElement, spanInButton);
        this.renderer.setAttribute(this.el.nativeElement, 'aria-label', 'Chargement en cours');
    }

    /**
     * reset style on button
     */
    private resetButton(): void {
        this.isClicked = false;
        this.renderer.removeAttribute(this.el.nativeElement, 'data-ob1-component');
        this.renderer.removeAttribute(this.el.nativeElement, 'aria-label');
        const span = this.renderer.selectRootElement('.ob1-progress-bar-determined');
        this.renderer.removeChild(this.el.nativeElement, span);
        this.renderer.removeAttribute(this.el.nativeElement, 'disabled');
    }
}
